import { createSlice, type PayloadAction } from '@reduxjs/toolkit';
import type { PathologyTO, TagTO } from '../../lib';

interface PreferencesState {
  initialized?: boolean;
  pathologies?: string[];
  allPathologies?: PathologyTO[];
  hiddenPathologies?: string[];
  tags?: TagTO[];
  allTags?: TagTO[];
  hiddenTags?: string[];
  hiddenTasks?: string[];
}

const initialState: PreferencesState = {
  initialized: false,
  allPathologies: [],
  pathologies: [],
  hiddenPathologies: [],
  tags: [],
  allTags: [],
  hiddenTags: [],
  hiddenTasks: [],
};

export const preferencesSlice = createSlice({
  name: 'preferences',
  initialState,
  reducers: {
    setPreferences(state, action: PayloadAction<PreferencesState>) {
      return { ...state, ...action.payload };
    },
  },
});

export const { setPreferences } = preferencesSlice.actions;
